export default {
  paymentResult: (state) => {
    return state.paymentResult;
  },

  transits: (state) => {
    return state.transits;
  },
  transit: (state) => {
    return state.transit;
  },
  transitCode: (state) => {
    return state.transitCode;
  },

  fieldReports: (state) => {
    return state.fieldReports;
  },
  fieldReport: (state) => {
    return state.fieldReport;
  },
  fieldReportCode: (state) => {
    return state.fieldReportCode;
  },

  meterReadings: (state) => {
    return state.meterReadings;
  },
  meterReadingCode: (state) => {
    return state.meterReadingCode;
  },
  meterReadingAdminCode: (state) => {
    return state.meterReadingAdminCode;
  },

  waterBills: (state) => {
    return state.waterBills;
  },
  waterBill: (state) => {
    return state.waterBill;
  },
  waterBillCode: (state) => {
    return state.waterBillCode;
  },

  chargeBills: (state) => {
    return state.chargeBills;
  },
  chargeBill: (state) => {
    return state.chargeBill;
  },
  chargeBillCode: (state) => {
    return state.chargeBillCode;
  },

  automations: (state) => {
    return state.automations;
  },
  automation: (state) => {
    return state.automation;
  },
  automationCode: (state) => {
    return state.automationCode;
  },
  automationCartable: (state) => {
    return state.automationCartable;
  },

  serviceRequests: (state) => {
    return state.serviceRequests;
  },
  serviceRequest: (state) => {
    return state.serviceRequest;
  },
  serviceRequestCode: (state) => {
    return state.serviceRequestCode;
  },

  billboardRequests: (state) => {
    return state.billboardRequests;
  },
  billboardRequest: (state) => {
    return state.billboardRequest;
  },
  billboardRequestCode: (state) => {
    return state.billboardRequestCode;
  },
  billboardRequestAdminCode: (state) => {
    return state.billboardRequestAdminCode;
  },
  billboardReserveDate: (state) => {
    if (state.billboardReserveDate) {
      const monthNames = {
        "01": "فروردین",
        "02": "اردیبهشت",
        "03": "خرداد",
        "04": "تیر",
        "05": "مرداد",
        "06": "شهریور",
        "07": "مهر",
        "08": "آبان",
        "09": "آذر",
        10: "دی",
        11: "بهمن",
        12: "اسفند",
      };

      let array = state.billboardReserveDate.reduce(
        (acc, { dateLocal, isReserved }) => {
          const [year, month] = dateLocal.split("/");
          const monthName = monthNames[month];
          const key = `${year}/${month} ‑ ${monthName}`;

          if (!acc[key]) acc[key] = [];
          acc[key].push({ dateLocal, isReserved });
          return acc;
        },
        {}
      );
      state.billboardReserveDate = array;
    }
    return state.billboardReserveDate;
  },
  isBillboardReserveDate: (state) => {
    return state.isBillboardReserveDate;
  },

  transactions: (state) => {
    return state.transactions;
  },
  lastVoucherInfo: (state) => {
    return state.lastVoucherInfo;
  },
};
